
/**
 * 時間戳記轉日期與時間(依照ISO 8601)
 * 如
 * 輸入: 1551575222000
 * 輸出當地時間: 2019-03-03 09:07:02
 */
function dateAndTimeFromTimestamp(timestamp) {
    let dateObj = new Date(timestamp);
    let year = dateObj.getFullYear();
    let month =(dateObj.getMonth() + 1) < 10 ? ("0" + (dateObj.getMonth() + 1)) : (dateObj.getMonth() + 1);
    let date =dateObj.getDate() < 10 ? ("0" + dateObj.getDate()) : dateObj.getDate();
    let hours =dateObj.getHours() < 10 ? ("0" + dateObj.getHours()) : dateObj.getHours();
    let minutes =dateObj.getMinutes() < 10 ? ("0" + dateObj.getMinutes()) : dateObj.getMinutes();
    let seconds = dateObj.getSeconds() < 10 ? ("0" + dateObj.getSeconds()) : dateObj.getSeconds();
    
    return `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`
}

/**
 * 取得時區，如台灣時區會返回+0800
 */
function getTimezone() {
    // 時區偏移量
    const timezoneOffset = new Date().getTimezoneOffset()

    // 時區偏移量轉為正整數
    let positiveTimezoneOffset = timezoneOffset
    if(positiveTimezoneOffset < 0) {positiveTimezoneOffset = timezoneOffset * -1}

    // 時區的時
    let hours = Math.floor(positiveTimezoneOffset/60)
    if(hours < 10) {hours = "0" + hours}

    // 時區的分
    let minutes = positiveTimezoneOffset%60
    if(minutes < 10) {minutes = "0" + minutes}

    // 時區的正負符號
    let sign = "-"
    if(timezoneOffset==0 || (timezoneOffset*-1)>0) {sign = "+"}

    return sign + hours + minutes
}

/**
 * 取得GMT時區，如台灣時區會返回GMT+0800
 **/
function getGMTTimezone() {
    return "GMT" + getTimezone()
}

/**
 * 取得UTC時區，如台灣時區會返回UTC+0800
 **/
function getUTCTimezone() {
    return "UTC" + getTimezone()
}

/**
 * 給予timestamp，返回包含日期、時間、UTC時區的字串
 * 如
 * 作業系統時區為+8
 * 輸入: 1611114373000
 * 輸出: 2021-01-20 11:46:13 UTC+0800
 */
function getdateAndTimeAndUTCTimezoneFromTimestamp(timestamp) {
    return dateAndTimeFromTimestamp(timestamp) + " " + getUTCTimezone()
}

/**
 * 給予timestamp，返回包含日期、時間、GMT時區的字串
 * 如
 * 作業系統時區為+8
 * 輸入: 1611114373000
 * 輸出: 2021-01-20 11:46:13 GMT+0800
 */
function getdateAndTimeAndGMTTimezoneFromTimestamp(timestamp) {
    return dateAndTimeFromTimestamp(timestamp) + " " + getGMTTimezone()
}




export default {
    dateAndTimeFromTimestamp,
    getdateAndTimeAndUTCTimezoneFromTimestamp,
    getdateAndTimeAndGMTTimezoneFromTimestamp,
}